export default __webpack_public_path__ + "media/cloud-video-thumbnail.90626c50.jpg";